 /*
 * @Author: lc 2631402207@qq.com
 * @Date: 2025-07-07 16:28:07
 * @LastEditors: lc 2631402207@qq.com
 * @LastEditTime: 2025-09-25 08:51:43
 * @FilePath: \ui\src\pages\ImageGenPage\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react'
import { useParams } from 'react-router-dom'
import ImageGenLandingView from './components/ImageGenLandingView'
import ImageGenConversationView from './components/ImageGenConversationView'

const ImageGenPage: React.FC = () => {
  const { conversationId } = useParams<{ conversationId: string }>()
  return (
    <>
      {conversationId ? (
        <ImageGenConversationView conversationId={conversationId} />
      ) : (
        <ImageGenLandingView />
      )}
    </>
  )
}

export default ImageGenPage
